import dynamic from "next/dynamic";
const PanoramaCardsCarouselTabsComponent = dynamic(()=>import("./panorama-cards-carousel-tabs-component"));
import PanoramaCardsCarouselTabsConfig from "./panorama-cards-carousel-tabs-config";
import PanoramaCardsCarouselTabsAdvancedConfig from "./panorama-cards-carousel-tabs-advanced-config";
export default {
    PanoramaCardsCarouselTabsComponent,
    PanoramaCardsCarouselTabsConfig,
    PanoramaCardsCarouselTabsAdvancedConfig
};
